<template>
  <!-- 技师提交资料 -->
  <div class="jsFrom">
    <div class="title">完善资料</div>
    <p class="item">基本信息</p>
    <el-card>
      <el-row>
        <el-col :span="4" :xs="6"> <i class='el-icon-star-on iconStart'></i> 姓名</el-col>
        <el-col :span="20" :xs="16">
          <el-input v-model="addObj.name" placeholder="请输入姓名"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" :xs="6" > <i class='el-icon-star-on iconStart'></i>性别</el-col>
        <el-col :span="20" :xs="16">
          <el-radio v-model="addObj.gender" :label="1">男</el-radio>
          <el-radio v-model="addObj.gender" :label="2">女</el-radio>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" :xs="6"><i class='el-icon-star-on iconStart'></i>年龄</el-col>
        <el-col :span="20" :xs="16">
          <el-input type='number' min='1' max='100' v-model="addObj.age" placeholder="请输入年龄"></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" :xs="6"><i class='el-icon-star-on iconStart'></i>家庭住址</el-col>
        <el-col :span="20" :xs="16">
          <selectCity ref="setCity" :isXian="true" :isStreet="true" @Citychange="homeAddress" class="inLine"/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" :xs="6"><i class='el-icon-star-on iconStart'></i>入职前服务工龄</el-col>
        <el-col :span="20" :xs="16">
          <el-input type='number' min='1' max='100' v-model="addObj.workAge" placeholder="请输入入职前服务工龄"></el-input>
        </el-col>
      </el-row>
    </el-card>
    <p class="item">服务信息</p>
    <el-card>
      <el-row>
        <el-col :span="4" :xs="6"><i class='el-icon-star-on iconStart'></i>服务范围</el-col>
        <el-col :span="20" :xs="16">
          <selectCity class="city" :isXian="true" @Citychange="serviceAddress"/>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="4" :xs="6" class='serviceType'><i class='el-icon-star-on iconStart'></i>服务品类</el-col>
        <el-col :span="20" :xs="18" class='serviceType' >
          <el-checkbox-group v-model="serviceType">
            <el-checkbox v-for="(val,key) in typeBox" :key="key" :label="val.id">{{ val.name }}</el-checkbox>
          </el-checkbox-group>
        </el-col>
        <el-col :span="4" :xs="6" class='serviceType jsType'><el-button class="summit summitPc" type="small" @click="check">申请加入</el-button></el-col>
      </el-row>
      <div class='phone'>
        <el-button class="summit" type="small" @click="check">申请加入</el-button>
      </div>
    </el-card>

  </div>
</template>

<script>
import selectCity from '@/components/common/testCity';
import { productApi, workApi } from '@/api';
import { addJs } from '@/api/params/work';
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      serviceType: [],
      typeBox: [],
      addObj: Object.assign(addJs, {})
    };
  },
  components: {
    selectCity
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    // 技师详情
    async getJsId () {
      let a = localStorage.getItem('id_user') ? JSON.parse(localStorage.getItem('id_user')) : {}
      if (!a) {

      }
      let userId = null
      if (a.identityList) {
        a.identityList.forEach(val => {
          if (val.userType === 2) {
            userId = val.userId
          }
        })
      } else {
        return false
      }

      if (!userId) {
        return false
      }
      let result = await workApi.getJsId(userId)
      if (result.data.statusCode === 200) {
        this.addObj.id = result.data.data
      }
    },
    // 获取服务类
    async getType() {
      let result = await productApi.getSkillTree();
      if (result.data.statusCode === 200) {
        this.typeBox = result.data.data;
      }
    },
    // 去审核页面
    async check() {
      var box = [];
      this.serviceType.forEach(val => {
        box.push(val);
      });
      if (this.$route.query.jsId) {
        this.addObj.id = this.$route.query.jsId
      }
      if (this.$route.query.source) {
        this.addObj.source = this.$route.query.source
      }
      this.addObj.intentionalSkillIds = box.join(',')
      let result = await workApi.jsCheck(this.addObj);
      if (result.data.statusCode === 200) {
        this.$router.push({
          path: '/worker/checkResult',
          query: {
            userType: this.$route.query.userType,
            addId: result.data.data ? result.data.data : this.$route.query.jsId
          }
        });
      }
    },
    // 家庭住址
    homeAddress(result) {
      this.addObj.provinceId = result.sheng.code;
      this.addObj.cityId = result.shi.code;
      this.addObj.areaId = result.xian.code;
      this.addObj.streetId = result.street ? result.street.code : ''
    },
    // 服务地址
    serviceAddress(result) {
      this.addObj.serviceProvinceId = result.sheng.code;
      this.addObj.serviceCityId = result.shi.code;
      this.addObj.serviceAreaId = result.xian.code;
    }
  },
  created() {
    this.getType();
  },
  // activated () {
  //   if (!this.$route.query.jsId) {
  //     this.getJsId()
  //   }
  // }
};
</script>

<style scoped lang='less'>
@import "../../assets/styles/work.less";
</style>

